// the nav v3 version lives in src/components/navigation/src/components/horizontal-nav/product-home.tsx
import { BitbucketIcon } from '@atlaskit/logo';
import { AppLogo } from '@atlaskit/navigation-system/top-nav-items';

// new pride assets for nav v4
import prideIconSvg from './bbc-pride-icon-new.svg';
import { useTopNavData } from './hooks';

const PrideIcon = () => <img src={prideIconSvg} alt="BBC Pride Icon" />;
const SizedBitbucketIcon = () => (
  <BitbucketIcon shouldUseNewLogoDesign size="small" />
);

export const TopNavAppLogo = (): JSX.Element => {
  const { hasPride } = useTopNavData();

  const sharedProps = {
    href: '/',
    label: 'Bitbucket',
    // onClick: () => {}, // TODO analytics later
  };

  return (
    <AppLogo
      icon={hasPride ? PrideIcon : SizedBitbucketIcon}
      name="Bitbucket"
      {...sharedProps}
    />
  );
};
